/* contentEditable rich text editor ported from the prototype's PostEditorBody.
   value = HTML string; onChange(html). Uses execCommand (deprecated but adequate
   for a single trusted admin author; output is sanitized on render via RichText). */
import { useEffect, useRef } from "react";
import Icon from "./Icon.jsx";

export default function RichTextEditor({ value, onChange, instanceKey }) {
  const bodyRef = useRef(null);

  // Sync incoming value into the DOM only when switching documents, so typing
  // (which mutates the DOM directly) doesn't reset the caret.
  useEffect(() => {
    if (bodyRef.current && bodyRef.current.innerHTML !== (value || "")) {
      bodyRef.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instanceKey]);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    if (bodyRef.current) onChange(bodyRef.current.innerHTML);
  };
  const onInput = () => {
    if (bodyRef.current) onChange(bodyRef.current.innerHTML);
  };

  const wordCount = (value || "").replace(/<[^>]*>/g, " ").trim().split(/\s+/).filter(Boolean).length;

  return (
    <div className="editor">
      <div className="editor__toolbar">
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("bold")} title="Bold"><Icon.Bold size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("italic")} title="Italic"><Icon.Italic size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("underline")} title="Underline"><Icon.Underline size={16} /></button>
        <div className="editor__toolbar-sep" />
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("formatBlock", "<h2>")} title="Heading 2"><Icon.Heading2 size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("formatBlock", "<h3>")} title="Heading 3"><Icon.Heading3 size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("formatBlock", "<p>")} title="Paragraph"><span style={{ fontWeight: 600, fontSize: 12 }}>P</span></button>
        <div className="editor__toolbar-sep" />
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("insertUnorderedList")} title="Bullet list"><Icon.List size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("insertOrderedList")} title="Numbered list"><Icon.ListOrdered size={16} /></button>
        <div className="editor__toolbar-sep" />
        <button type="button" className="editor__toolbar-btn" onClick={() => { const url = prompt("Link URL?"); if (url) exec("createLink", url); }} title="Add link"><Icon.Link size={16} /></button>
        <div className="editor__toolbar-sep" />
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("undo")} title="Undo"><Icon.Undo size={16} /></button>
        <button type="button" className="editor__toolbar-btn" onClick={() => exec("redo")} title="Redo"><Icon.Redo size={16} /></button>
      </div>
      <div
        ref={bodyRef}
        className="editor__body prose"
        contentEditable
        suppressContentEditableWarning
        onInput={onInput}
        style={{ maxWidth: "none" }}
      />
      <div className="editor__counter">{wordCount} words</div>
    </div>
  );
}
